import React from 'react';

import {
  Logs,
  Log,
  LogText,
  HTMLRender,
  Chip,
  makeStyles,
  CommentIcon,
} from '@gogame/components';

import { getColor } from '../../Status';

const useStyles = makeStyles(() => ({
  icon: {
    alignSelf: 'flex-start',
  },
  comment: {
    height: 'auto',
    padding: '8px',
    '& .MuiChip-label': {
      display: 'block',
      whiteSpace: 'normal',
    },
  },
}));
const ActionsLog = ({ logs }) => {
  const classes = useStyles();
  return (
    <Logs empty={!logs?.length}>
      {logs?.map((log) => {
        let actionLabel = log.action;
        if (log.invoiceId) {
          actionLabel = `Invoice #${
            log.invoiceId
          } ${actionLabel.toLowerCase()}`;
        }

        return (
          <Log color={getColor(log.status?.id)}>
            <LogText
              date={log.date}
              action={actionLabel}
              user={log.user}
              status={log.status?.name}
            >
              {log.comment && (
                <Chip
                  icon={
                    <CommentIcon
                      sx={{ fontSize: 16 }}
                      className={classes.icon}
                    />
                  }
                  className={classes.comment}
                  label={<HTMLRender value={log.comment} />}
                />
              )}
            </LogText>
          </Log>
        );
      })}
    </Logs>
  );
};

export default ActionsLog;
